import PlatformType from '../enums/PlatformType';
import BotType from '../enums/BotType';
import { globalConstants } from '../constants/globalConstants'

class GlobalStoreService {
  constructor() {
    this._store = {

      currentNumber: null,
      currentNumberType: null,
      primaryNumber: null,
      primaryNumberType: null,
      isUserLoggedIn: false,
      userProfileType: null,

      platformType: PlatformType.WEB,

      currentBotType: BotType.POSTPAID,

      // default scenario list
      scenarioList: {
        [BotType.POSTPAID]: [],
        [BotType.PREPAID]: [],
        [BotType.PAYMENTS_BANK]: []
      },

      // for logged out users
      basicToken: null,

      // for logged in users
      loggedInToken: null,
      // component state

      components_handler: {
        //bottom bar comp can be --- 'chat-bar-comp' || 'user-accounts-menu-comp' || 'login-comp' || 'cancel-comp'||'switch-bar-comp'
        bottom_bar_comp: globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR
      },

      //maintained for alternate no intent found 1 and no intent found 2
      no_intent_found_1: false,

      //options from category fetch
      categoriesFetched: {
        [BotType.POSTPAID]: undefined,
        [BotType.PREPAID]: undefined,
      },

      // Handling for previuos step
      chatHistoryForCurrentScenario: [],

      // Maintain context for login via otp 
      loginViaOtp: false,

      // Tracking data for analytics
      trackingData: {
        circle: "",
        enteredTextMode: "click",
        startTime: new Date(),
        user_response: "",
        queryCount: 0,
        current_scenario: {},
        isIdleChat: true,
        isIdleChatCallled: false
      },
      chatBotHistory: {
        dbWriteStatus: true,
      },


    };
  }

  get(key) {
    return this._store[key];
  }

  set(key, value) {
    this._store[key] = value;
  }
}

export default new GlobalStoreService();



// WEBPACK FOOTER //
// ./src/services/global-store.service.js